import { getExternalLinks } from '@config/appConfig';
import { useGlobalDIContext } from '@context/GlobalDIContext';
import { TRANSACTION_ROUTES } from '@features/transaction/routes';
import { useCheckAuth } from '@features/user/states';
import { useGetClientPermission } from '@features/user/states/queries/useGetClientPermission';
import { Iconify } from '@g2-shared/components';
import { WuLayoutHeaderMenuDropdown } from '@layout/components/WuLayoutHeaderMenuDropdown';
import WuLayoutHeaderRightMenu from '@layout/components/WuLayoutHeaderRightMenu';
import WuLayoutMenuLogo from '@layout/components/WuLayoutMenuLogo';
import WuLayoutMobileMenu from '@layout/components/WuLayoutMobileMenu';
import { layoutStyle } from '@layout/styles';
import { Box, Button, Link, MenuItem } from '@mui/material';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import i18n from 'i18next';

function WuLayoutHeader() {
  const EXTERNAL_LINKS = getExternalLinks(i18n.language);

  const { TranslationAdapter } = useGlobalDIContext();
  const { isAuthenticated } = useCheckAuth();
  const { hasSubService } = useGetClientPermission(!!isAuthenticated);
  const { t } = TranslationAdapter();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box sx={layoutStyle.layoutMenuWrapper}>
      <Box sx={layoutStyle.layoutMenu}>
        <RouterLink to="/">
          <WuLayoutMenuLogo />
        </RouterLink>
        <Box sx={layoutStyle.layoutMenuLinks}>
          {isAuthenticated && hasSubService('WUD') && (
            <RouterLink style={layoutStyle.layoutMenuLink} to={TRANSACTION_ROUTES.sendMoney}>
              {t('sendMoney')}
            </RouterLink>
          )}
          <Button
            id="main-menu-button"
            aria-controls={open ? 'profile-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}
            sx={layoutStyle.layoutMenuLink}
          >
            {t('menu')}
            <Iconify icon="mingcute:down-fill" sx={{ ml: 2 }} />
          </Button>
        </Box>
        <WuLayoutHeaderMenuDropdown
          id="main-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'profile-menu-button',
          }}
        >
          {isAuthenticated && hasSubService('WUD') && (
            <RouterLink style={layoutStyle.menuDropdownLink} to={TRANSACTION_ROUTES.sendMoney}>
              <MenuItem sx={{ fontSize: 15 }} onClick={handleClose}>
                {t('sendMoney')}
              </MenuItem>
            </RouterLink>
          )}
          <RouterLink style={layoutStyle.menuDropdownLink} to={EXTERNAL_LINKS.trackTransaction}>
            <MenuItem sx={{ fontSize: 15 }} onClick={handleClose}>
              {t('trackTransaction')}
            </MenuItem>
          </RouterLink>
          <Link sx={layoutStyle.menuDropdownLink} href={EXTERNAL_LINKS.findLocation}>
            <MenuItem sx={{ fontSize: 15 }} onClick={handleClose}>
              {t('findLocation')}
            </MenuItem>
          </Link>
          <Link sx={layoutStyle.menuDropdownLink} href={EXTERNAL_LINKS.findLocationForVerification}>
            <MenuItem sx={{ fontSize: 15 }} onClick={handleClose}>
              {t('findLocationForVerification')}
            </MenuItem>
          </Link>
          <Link sx={layoutStyle.menuDropdownLink} href={EXTERNAL_LINKS.findLocationForVerification}>
            <MenuItem sx={{ fontSize: 15 }} onClick={handleClose}>
              {t('customerSupport')}
            </MenuItem>
          </Link>
        </WuLayoutHeaderMenuDropdown>
        <WuLayoutHeaderRightMenu />
        <WuLayoutMobileMenu />
      </Box>
    </Box>
  );
}

export default WuLayoutHeader;
